var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32580_352357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9953 2.50781C8.09531 2.50781 2.50781 8.10781 2.50781 15.0078C2.50781 21.9078 8.09531 27.5078 14.9953 27.5078C21.9078 27.5078 27.5078 21.9078 27.5078 15.0078C27.5078 8.10781 21.9078 2.50781 14.9953 2.50781ZM15.0078 25.0078C9.48281 25.0078 5.00781 20.5328 5.00781 15.0078C5.00781 9.48281 9.48281 5.00781 15.0078 5.00781C20.5328 5.00781 25.0078 9.48281 25.0078 15.0078C25.0078 20.5328 20.5328 25.0078 15.0078 25.0078Z",
    fill: "#1F3864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6328 8.74219H13.7578V16.2422L20.3203 20.1797L21.2578 18.6422L15.6328 15.3047V8.74219Z",
    fill: "#1F3864"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.0a33f1d3ad3cb2b796c97e974309612c.svg";
export { ForwardRef as ReactComponent };